import { Actions } from './styled';

export const ModalActions = Actions;
